import constants from "../../../core/constants";
import apis from "../../../core/apis";

class Controller {
  constructor(
    $mdDialog,
    types,
    Upload,
    invoice,
    contractor,
    Events,
    systemCategories
  ) {
    "ngInject";

    this.invoice = invoice;
    this.contractor = contractor;
    this.types = types;
    this.$mdDialog = $mdDialog;
    this.Upload = Upload;
    this.Events = Events;
    this.systemCategories = systemCategories;
    this.selectedCategory = undefined;
  }

  $onInit() {
    this.invoicesList = this.types;

    this.clear = () => {
      delete this.file;
    };
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.category_id = this.selectedCategory.id;

    if (this.amount && this.note && this.file) {
      const amount = this.amount * constants.currencyBy;
      const note = this.note;
      const type = this.invoiceType;
      const extraField = this.extraField;
      const data = {
        file: this.file,
        amount,
        note,
        type,
        category_id: this.category_id,
        invoice: this.invoice,
        contractor: this.contractor,
      };

      this.Upload.upload({
        url: apis.invoiceItem,
        data,
      }).then(
        () => {
          this.Events.emit(showNotificationEvent, {
            message: "Your file has been uploaded successfully",
          });
          this.$mdDialog.cancel();
          this.$mdDialog.hide({
            amount,
            note,
            type,
            ...extraField,
          });
          this.isUploading = false;
          delete this.file;
          delete this.amount;
          delete this.note;
          delete this.type;
        },
        (response) => {
          const message = response.data.message || "Can't upload your file !";
          this.$mdDialog.cancel();
          this.Events.emit(errorEvent, { message });
          this.isUploading = false;
          this.$mdDialog.hide({
            amount,
            note,
            type,
            ...extraField,
          });
        }
      );
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/bonusDialog/bonusDialog.controller.js